import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";

const UserAnalyticsForTeacher = () => {
  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <Box sx={{ width: "90%", maxWidth: 860, mx: "auto", pt: { xs: 12, md: 16 }, textAlign: "center" }}>
        <Typography variant="h5" sx={{ fontWeight: 900, color: "#241B3A" }}>
          Teacher analytics moved to Teacher Mode
        </Typography>
        <Typography sx={{ mt: 1, color: "#6B6478" }}>
          Open an approved student from Teacher Mode to view their results.
        </Typography>
        <Button sx={{ mt: 3 }} variant="contained" onClick={() => navigate("/teacher-mode")}>
          Open Teacher Mode
        </Button>
      </Box>
    </>
  );
};

export default UserAnalyticsForTeacher;
